module.exports = __webpack_public_path__ + "img/162117.9b566838.jpg";